import * as React from "react";
import * as ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import { unregister as unregisterServiceWorker } from "./registerServiceWorker";

import "normalize.css/normalize.css";

import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/select/lib/css/blueprint-select.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Provider } from "unstated";

ReactDOM.render(
	<Provider>
		<App />
	</Provider>,
	document.getElementById("root") as HTMLElement
);
unregisterServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx